import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FlexibleContainer } from "../containers/styledComponents";
import { LegendCircle } from "../visuals/styledComponents";
import { CompassParagraph } from "../common/styledComponents";
import { ROUTES } from "../../routes/routeNames";
import { WsQParamType } from "../../models/workflowModels";

const Titlecontainer = styled(FlexibleContainer)`
  cursor: pointer;
`;

const CircleTag = styled(LegendCircle)<{ textColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-family: "Apercu";
  font-weight: 800;
  color: ${({ textColor }): string => textColor};
`;

const UnderlineParagraph = styled(CompassParagraph)`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const buildSearchParams = (id: string, idType: "taskId"): string => {
  const params = new URLSearchParams({
    [idType]: id,
  }).toString();
  return `?${params}`;
};

export const TitleWithCircleTag = ({
  taskId,
  title,
  color,
  type,
  bg,
}: TitleWithCircleTagProps): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Titlecontainer
      ai="center"
      jc="flex-start"
      onClick={(): void => {
        navigate({
          pathname: `${ROUTES.WORKSPACE}/${WsQParamType.VIEW_TASK}`,
          search: buildSearchParams(taskId, "taskId"),
        });
      }}
    >
      <CircleTag color={bg} size={24} textColor={color}>
        {type[0].toUpperCase()}
      </CircleTag>
      <UnderlineParagraph ml={5}>{title}</UnderlineParagraph>
    </Titlecontainer>
  );
};

export type TitleWithCircleTagProps = {
  taskId: string;
  title: string;
  color: string;
  type: string;
  bg: string;
};
